module.exports = __webpack_public_path__ + "static/gallery-20-e643723635d825b15460bf365a5a3b02.jpg";